<template>
  <v-app>
    <app-bar :links="[]" />
    <v-main>
      <NotifyContainer />
      <v-progress-linear absolute indeterminate :active="loading" />
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-main>
  </v-app>
</template>
<script>
import AppBar from "./AppBar.vue";
import { loadingComputed } from "../vuex/helpers";
import NotifyContainer from "@/components/NotifyContainer.vue";

export default {
  name: "AuthLayout",
  components: {
    AppBar,
    NotifyContainer,
  },
  computed: {
    ...loadingComputed,
  },
};
</script>
